import React from "react";
import { ArrowRight } from "lucide-react";
import { finalCta } from "../mock";

export default function FinalCTA() {
  return (
    <section id="contact" className="relative overflow-hidden bg-transparent pb-28 pt-10">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="reveal grad-teal relative overflow-hidden rounded-[2.5rem] px-6 py-16 md:px-16 md:py-24">
          <div className="relative z-10 flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
            <div>
              <p className="font-display text-6xl text-black sm:text-7xl md:text-8xl">{finalCta.small}</p>
              <p className="font-display text-6xl text-black sm:text-7xl md:text-8xl">{finalCta.big}</p>
              <p className="mt-6 max-w-md text-base leading-relaxed text-black/70">{finalCta.note}</p>
            </div>
            <a href="mailto:info@all-about-artists.de?subject=Bring%20us%20your%20dream%20%E2%80%93%20Anfrage%20an%20CRTR%20Studio" className="group flex flex-none items-center gap-4 rounded-full bg-black py-3 pl-8 pr-3">
              <span className="mono-label text-sm text-[var(--crtr-yellow)]">{finalCta.cta}</span>
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--crtr-yellow)] transition-transform group-hover:translate-x-1">
                <ArrowRight className="h-5 w-5 text-black" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
